import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { BasicLayoutComponent } from './basicLayout.component';
import { BlankLayoutComponent } from './blankLayout.component';

import { NavigationComponent } from './../navigation/navigation.component';
import { FooterComponent } from './../footer/footer.component';
import { TopNavbarComponent } from './../topnavbar/topnavbar.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PasswordComponent } from './password/password.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        BsDropdownModule.forRoot(),
        SharedModule,
        FooterComponent,
        BasicLayoutComponent,
        BlankLayoutComponent,
        NavigationComponent,
        TopNavbarComponent,
        HomeComponent,
        LoginComponent,
        PasswordComponent,
    ],
    exports: [
        FooterComponent,
        BasicLayoutComponent,
        BlankLayoutComponent,
        NavigationComponent,
        TopNavbarComponent,
    ],
})
export class LayoutsModule {}
